import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '@app/core/shell/services/configuration.service';


@Injectable({
    providedIn: 'root'
})
export class RepairService {

    constructor(private http: HttpClient, private configService: ConfigurationService) { }

    getRepairJob(repairId: string, repairJobId: string, userId: string, tenancyReference: string): Observable<any> {
        const repairsApiUrl = this.configService.getConfig()?.shell.api.repairsApiUrl;
        //const repairsApiUrl = 'https://connect.api.local/repairs/'//this.configService.getConfig()?.shell.api.repairsApiUrl;
        return this.http.get<any>(repairsApiUrl + 'repairs/' + repairId + '/repairJobs/' + repairJobId + '?userId=' + userId + '&tenancyReference=' + tenancyReference);

    }

    postRepairForm(repairJobId: string, form: any, formType: string) {
        const repairsApiUrl = this.configService.getConfig()?.shell.api.repairsApiUrl;// 'https://connect.api.local/repairs/' + 'repairsForm';
        const url = repairsApiUrl + 'repairsForm';
        const repairForm = {
            repairJobId: repairJobId,
            form: form,
            formType: formType
        };

        return this.http.post(url, repairForm, {
            headers: { "Content-Type": "application/json; charset=UTF-8" }
        });
    }
}
